import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import PostsSerializer from './base';

export default class Post extends PostsSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    mediaIds: { serialize: 'ids' },
    groupIds: { serialize: 'ids' },
    goalIds: { serialize: 'ids' },
  };
}
